<div class="qr-warpper">
  <div class="qr-code">
    <img *ngIf="!code?.status" loading="lazy" src="/assets/images/payment/dummy_qr.png" alt="qr code">
    <div *ngIf="!code?.generated" class="qr-loader"><div class="loader"></div><div>loading</div></div>
    <div *ngIf="code?.generated && !code?.status" class="failed-qr"> <mat-icon>error</mat-icon> <span>Failed</span></div>
    <img *ngIf="code?.status" loading="lazy" [src]="'data:image/png;base64,'+code?.message" alt="qr code">
  </div>
  <div class="qr-desc">
    <div *ngIf="icons === 'paytm'" class="payment-icons-v1 PAYTM _PAYTM"></div>
    <div class="heading">Scan QR Code</div>
    <div class="text">{{title}}</div>
    <div *ngIf="icons === 'upi'" class="upi-icons">
      <span *ngFor="let item of (config?.paymentOptions?.options?.TOPUPI | keyvalue)" class="payment-icons-v1" [ngClass]="item?.key?.toUpperCase()"></span>
    </div>
  </div>
</div>